import axios, { AxiosError, AxiosResponse } from "axios";
// import { IEmailTemplate, ISaveTemplate } from "./models/EmailTemplate";
import { APP_Config } from "./utils/AppConfig";
import { BrandModels } from "./models/BrandModels";
import { LeadContactDetails, LeadModels } from "./models/LeadModels";
import { productDataModel } from "./models/ProductsModel";
import { InteractionHistoryModal } from "./models/InteractionHistoryModel";
import {
  FileData,
  actionItemsModel,
  getProductAndLocationModel,
} from "./models/ActionModel";
import { internalNotesModel } from "./models/InternalNotes";
import SaveContactDataType from "./models/RoldexModel";
import { RequestData, WatchlistItem } from "./models/WatchListModel";
import { claims, getUserDetailsPayload } from "./data/Payload";
import { ActivitySummary } from "./models/WidgestModels";
import { TodoModel, manualTodoHistory } from "./models/TodoModel";
import {
  MessageThreadModel,
  postMessageData,
  postMessageThreadData,
} from "./models/MessageCenterModels";
import { IAPIPayload, SubCategoryQuestionsForClientPortal, UserData } from "./models/SharedModel";
import CaseResponseModel from "./models/Cases/CaseResponseModel";
import {
  IAddCaseInput,
  ICaseCommentModel,
  ICaseDetailsModel,
  ICaseDocumentModel,
  ICaseTaskHistoryModel,
  ICaseTaskInput,
  ICaseTaskModel,
  IEditCaseTaskInput,
} from "./models/Cases/CaseDetailsModel";
import { State, suggestions } from "./components/layout/Leads/LeadDetails";
import { IActionBtnsModel, IDocuSignDocumentInput, ISignStatusModel } from "./models/StatusTabModel";
import { catchError } from "./utils/Utils";
import { HistoryInfo, SubCategoryQuestionsForCompliance, saveQuestionReview } from "./models/ComplianeQuestionarie";
import { OwnersForAdditionalInformation, OwnershipInformationdata, saveOwnershipInformationdata } from "./components/ClientPortal/ClientportalDashboardComponents/ReadonlyOwneshipQuestionnaireForm/ownershipForm/OwnershipInformationdata";
import { OverallPercentage } from "./models/ClientportalDashboardModels/GetResponseCategoreis";
import { postClientNotes } from "./models/Lead/LeadDetails";
import { CategoryDetails, postQuestionData } from "./models/ClientPortalCategoriesDetails/CategoriesDetails";
import { MessageThread } from "./models/QuestionarieMCModal";
import { SubCategoryQuestion } from "./components/ClientPortal/Questionarie/Question";

class Service {
  themeBaseUrl = APP_Config().REACT_APP_THEME_URL;
  baseUrl = APP_Config().REACT_APP_BASE_URL;
  CASE_BASE_URL = APP_Config().REACT_APP_CASE_BASE_URL;
  QUESTIONNAIRE_URL = APP_Config()?.REACT_APP_QUESTIONNAIRE_URL;
  getData = "prospect/getData";
  getClientContactsData="prospect/getClientContacts"
  postData = "prospect/postData";
  createOrUpdate = "prospect/createOrUpdateLead";
  updateData = "prospect/updateEntity";
  deleteData = "prospect/deleteData";
  updateUser = "users/updateUser"
  clientId = APP_Config().REACT_APP_CLIENT_ID;
  messageCenterUrl = APP_Config()?.REACT_APP_MESSAGE_CENTER_URL;
  docuSignUrl = APP_Config()?.REACT_APP_DOCU_SIGN_URL;
  BaseUrl = APP_Config().REACT_APP_BASE_URL;
  API_Base_Url = APP_Config().REACT_APP_BASE_URL;
  
  // EmailBaseUrl = APP_Config().REACT_EMAIL_BASE_URL;
  fetcher;

  constructor() {
    this.fetcher = axios.create();

    this.fetcher.interceptors.request.use((req: any) => {
      req.headers.Authorization = `Bearer ${localStorage.getItem("token")}`;
      return req;
    });

    this.fetcher.interceptors.response.use( (response) => {
        return response;
      },
      (error: any) => {
        const status = error.response ? error.response.status : null;
        if (error.response.config.url.indexOf("getRefreshToken") > -1) {
          return Promise.reject(error);
        }
        if (status === 401) {
          this.getRefreshToken().then((response:AxiosResponse)=>{
            if(response.data){
              localStorage.setItem("token",response.data.access_token);
              window.location.reload();
            }else{
              localStorage.removeItem('token');
              window.location.href=("/");
            }
          }).catch((er:any)=>{
            localStorage.removeItem('token');
            window.location.href=("/");
            console.log(er);
          });
          // const accesstoken = localStorage.getItem("token");
          // const refreshToken = localStorage.getItem("refreshToken");
          // window.location.href = `${
          //   APP_Config().REACT_APP_LOGOUT
          // }?accesstoken=${accesstoken}&refreshtoken=${refreshToken}`;
          // localStorage.clear();
          // window.location.href=("/error")
          // return Promise.reject(error);
        } else if (status === 403) {
          window.location.href = "/accessDenied";
        } else {
          return Promise.reject(error);
        }
      }
    );
  }

  // Login API

  getRefreshToken() {
    const token = localStorage.getItem("refreshToken");
    return this.fetcher.get(
      `${this.baseUrl}getRefreshToken?refreshToken=${token}&clientId=${this.clientId}`
    );
  }

  postapicall(code: any, clientId: any) {
    return this.fetcher.post(
      `${this.baseUrl}authorization/getToken?clientId=${clientId}&code=${code}`
    );
  }

  getUserDetails = () =>
    this.fetcher.post(
      `${this.baseUrl}users/getUserDetails`,
      getUserDetailsPayload
    );

  getClaims = (token: string,orgId:string) => {
    const config = {
      headers: { Authorization: `Bearer ${token}` },
    };
    const data ={...claims,orgId:orgId}
    return this.fetcher.post(
      `${this.baseUrl}prospect/getClaims`,
      data,
      config
    );
  };

  getBrandColors = (orgId: any): Promise<AxiosResponse<BrandModels[]>> =>
    this.fetcher.get(`${this.themeBaseUrl}theme/getBrandColors?orgId=${orgId}`);

  getLeadsData = (data: any): Promise<AxiosResponse<LeadModels>> =>
    this.fetcher.post(`${this.baseUrl}${this.getData}`, data);
  
    //getclietContacts
    getRolodexContactsData = (data: any): Promise<AxiosResponse<LeadModels>> =>
    this.fetcher.post(`${this.baseUrl}${this.getClientContactsData}`, data);

  //Tabs API calls

  // Internal Notes Apis
  getInternalNotes = (
    data: any
  ): Promise<AxiosResponse<internalNotesModel[]>> =>
    this.fetcher.post(`${this.baseUrl}${this.getData}`, data);

  deleteInternalNotes = (data: any) =>
    this.fetcher.post(`${this.baseUrl}${this.deleteData}`, data);

  getAllUsers = (data: any): Promise<AxiosResponse<UserData[]>> =>
    this.fetcher.post(`${this.baseUrl}${this.getData}`, data);

  saveInternalNotes = (data: any): Promise<AxiosResponse<any>> =>
    this.fetcher.post(`${this.baseUrl}${this.postData}`, data);

  deleteLike = (data: any) =>
    this.fetcher.post(`${this.baseUrl}${this.deleteData}`, data);

  getInteractionHistoryData = (
    data: any
  ): Promise<AxiosResponse<InteractionHistoryModal[]>> =>
    this.fetcher.post(`${this.baseUrl}${this.getData}`, data);

  getProductsData = (data: any): Promise<AxiosResponse<productDataModel[]>> =>
    this.fetcher.post(`${this.baseUrl}${this.getData}`, data);

  getDocuments = (documentId: string): Promise<AxiosResponse<FileData>> =>
    this.fetcher.get(`${this.baseUrl}prospect/getFileByDocId/${documentId}`);

   
  getClientActivity = (data: any) =>
  this.fetcher.post(`${this.baseUrl}${this.getData}`, data);

  deleteFile = (documentId: number, data: any) =>
    this.fetcher.post(`${this.baseUrl}prospect/deleteFile/${documentId}`, data);

    

  deleteFileDocumentsTab = (documentId: string) =>
    this.fetcher.post(`${this.baseUrl}prospect/deleteFile/${documentId}`);

  updateCasemanagementTodo = (data: any) =>
    this.fetcher.post(`${this.baseUrl}prospect/updateData`, data);
 
    updateManualTodo =(data: any) =>
    this.fetcher.post(`${this.baseUrl}users/updateTodo`, data);

  editProducts = (data: any) =>
    this.fetcher.post(`${this.baseUrl}${this.postData}`, data);

  getAccountsData = (data: any): Promise<AxiosResponse<any>> =>
    this.fetcher.post(`${this.baseUrl}${this.getData}`, data);

  uploadFilesDCT = async (files: any, data: any) => {
    const formData = new FormData();
    files?.forEach((file: any) => {
      formData.append("file", file);
    });
    formData.append("body", JSON.stringify(data));

    const config = {
      headers: {
        "content-type": "multipart/form-data",
      },
    };
    return this.fetcher.post(
      `${this.baseUrl}prospect/uploadGeneralDocuments`,
      formData,
      config
    );
  };
  uploadSummaryReport = async (files: any, data: any) => {
    const formData = new FormData();
   
    formData.append("file", files);
    
    formData.append("body", JSON.stringify(data));

    const config = {
      headers: {
        "content-type": "multipart/form-data",
      },
    };
    return this.fetcher.post(
      `${this.baseUrl}prospect/uploadSummaryReport`,
      formData,
      config
    );
  };
  getProductAndLocationByCPId = (
    data: any
  ): Promise<AxiosResponse<getProductAndLocationModel[]>> =>
    this.fetcher.post(`${this.baseUrl}${this.getData}`, data);

  downloadAllDocuments(
    clientId: string | undefined,
    clientProductId: string | undefined
  ) {
    return this.fetcher.get(
      `${this.baseUrl}prospect/downloadAllDocuments?clientId=${clientId}&clientProductsId=${clientProductId}`,
      { responseType: "blob" }
    );
  }

  getFoldersByProducts = (data: any): Promise<AxiosResponse<any>> =>
    this.fetcher.post(`${this.baseUrl}${this.getData}`, data);

  getActionsData = (data: any): Promise<AxiosResponse<actionItemsModel[]>> =>
    this.fetcher.post(`${this.baseUrl}${this.getData}`, data);

  getClientInteractionData = (data: any): Promise<AxiosResponse<any>> =>
    this.fetcher.post(`${this.baseUrl}${this.getData}`, data);

  getDropDownData = (data: any): Promise<AxiosResponse<any>> =>
    this.fetcher.post(`${this.baseUrl}${this.getData}`, data);

  getContactsData = (data: any): Promise<AxiosResponse<any>> =>
    this.fetcher.post(`${this.baseUrl}${this.getData}`, data);

  getEmailTypesData = (data: any): Promise<AxiosResponse<actionItemsModel[]>> =>
    this.fetcher.post(`${this.baseUrl}${this.getData}`, data);

  getPhoneTypesData = (data: any): Promise<AxiosResponse<actionItemsModel[]>> =>
    this.fetcher.post(`${this.baseUrl}${this.getData}`, data);

  getOrgProductsByOrgId = (data: any): Promise<AxiosResponse<any>> =>
    this.fetcher.post(`${this.baseUrl}${this.getData}`, data);

  saveActionItem = (data: any) =>
    this.fetcher.post(`${this.baseUrl}${this.postData}`, data);

    getArchiveDataByOrgId = (data: any): Promise<AxiosResponse<any>> =>
    this.fetcher.post(`${this.baseUrl}${this.getData}`, data);

  //getExisting contacts list
  getExistingContactsList = (data: any): Promise<AxiosResponse<LeadModels>> =>
    this.fetcher.post(`${this.baseUrl}${this.getData}`, data);

  //Create Lead

  createLead = (data: any): Promise<AxiosResponse<any>> =>
    this.fetcher.post(`${this.baseUrl}${this.createOrUpdate}`, data);

    UpdateBusinessInfoByName = (data: any): Promise<AxiosResponse<any>> =>
    this.fetcher.post(`${this.baseUrl}prospect/updateBusinessInfo`, data);
  //Create Lead Validation
  createLeadValidation = (data: any): Promise<AxiosResponse<any>> =>
    this.fetcher.post(`${this.baseUrl}${this.getData}`, data);

  //move to contact

  moveToContact = (data: any): Promise<AxiosResponse<any>> =>
    this.fetcher.post(`${this.baseUrl}${this.updateData}`, data);

  // saveRoldexContactData

  saveOrUpdateContactCard = (data: any) =>
    this.fetcher.post(`${this.baseUrl}prospect/createOrEditClientContact`, data);

  leadInfo = (data: any): Promise<AxiosResponse<any>> =>
    this.fetcher.post(`${this.baseUrl}prospect/postData`, data);

  deleteLabel = (data: any): Promise<AxiosResponse<any>> =>
    this.fetcher.post(`${this.baseUrl}prospect/deleteData`, data);

  reAssignClient = (data: any): Promise<AxiosResponse<any>> =>
    this.fetcher.post(`${this.baseUrl}prospect/updateData`, data);
  ////api to get documents or files by docId/////
  getLogo = (id: any): Promise<AxiosResponse<any>> =>
    this.fetcher.get(`${this.baseUrl}prospect/getFileByDocId/${id}`);
  //status tab
  getClients = (data: any): Promise<AxiosResponse<any>> =>
    this.fetcher.post(`${this.baseUrl}${this.getData}`, data);
  getHouseholdInfo = (data: any): Promise<AxiosResponse<any>> =>
    this.fetcher.post(`${this.baseUrl}${this.getData}`, data);

  /////getNotifications/////  
    getNotifications = (data: any): Promise<AxiosResponse<any>> =>
    this.fetcher.post(`${this.baseUrl}${this.getData}`, data);
    
    deleteNotifications = (data: any): Promise<AxiosResponse<any>> =>
    this.fetcher.post(`${this.baseUrl}users/updateNotifications`, data);

    updateNotificationFlag = (): Promise<AxiosResponse<any>> =>
    this.fetcher.post(`${this.baseUrl}users/updateNotificationFlag`);
  // Master Landing Page
  // Watch In Focus
  getWatchListByUserId = (data: any): Promise<AxiosResponse<WatchlistItem[]>> =>
    this.fetcher.post(`${this.baseUrl}${this.getData}`, data);

  addToWatchlist = (data: any): Promise<AxiosResponse<any>> =>
    this.fetcher.post(`${this.baseUrl}${this.postData}`, data);

  removeWatchList = (data: any) =>
    this.fetcher.post(`${this.baseUrl}${this.deleteData}`, data);

  getClientProductId = (data: any): Promise<AxiosResponse<any>> =>
    this.fetcher.post(`${this.baseUrl}${this.getData}`, data);

  //

  getAcceptStatus = (data: any): Promise<AxiosResponse<any>> =>
    this.fetcher.post(`${this.baseUrl}${this.getData}`, data);

  //Address suggestion

  getAddressSuggestions(search: string): Promise<AxiosResponse<suggestions>> {
    return this.fetcher.get<suggestions>(
      `${this.baseUrl}prospect/getAddressSuggestions?search=${search}`
    );
  }

  getFile(filePath: string) {
    return this.fetcher.get(`${this.BaseUrl}prospect/getFileByDocId/${filePath}`);
   }

  // stat Tiles

  getStatTiles = (data: any): Promise<AxiosResponse<ActivitySummary[]>> =>
    this.fetcher.post(`${this.baseUrl}${this.getData}`, data);

  getBtnsByClientDetails = (
    data: any
  ): Promise<AxiosResponse<IActionBtnsModel[]>> =>
    this.fetcher.post(`${this.baseUrl}${this.getData}`, data);
  //files upload

  filesSaveAttachment = async (files: any, data: any) => {
    const formData = new FormData();
    files.forEach((file: any) => {
      formData.append("file", file);
    });
    formData.append("body", JSON.stringify(data));

    const config = {
      headers: {
        "content-type": "multipart/form-data",
      },
    };
    return this.fetcher
      .post(`${this.baseUrl}prospect/fileUpload`, formData, config)
      .then((response) => response)
      .catch((error) => {
        catchError(error, true);
      });
  };

  // Quick Links

  getUserShortcutsByUserId = (data: any): Promise<AxiosResponse<any>> =>
    this.fetcher.post(`${this.baseUrl}${this.getData}`, data);

  getQuickLinks = (data: any): Promise<AxiosResponse<any>> =>
    this.fetcher.post(`${this.baseUrl}${this.getData}`, data);

  deleteQuickLink = (data: any) =>
    this.fetcher.post(`${this.baseUrl}${this.deleteData}`, data);

  createUserShortcut(body: any) {
    return this.fetcher.post<any>(`${this.baseUrl}${this.postData}`, body);
  }

  todoStatusChange = (
    taskId: string,
    status: string
  ): Promise<AxiosResponse<any>> =>
    this.fetcher.put(
      `${this.CASE_BASE_URL}finresult/updateTaskStatus?taskId=${taskId}&status=${status}`
    );

  getTodoById = (data: any): Promise<AxiosResponse<any>> =>
    this.fetcher.post(`${this.baseUrl}${this.getData}`, data);

  // getTaskHistory = (taskId: string) =>
  //   this.fetcher.get(
  //     `${this.CASE_BASE_URL}finresult/getTaskHistorybyTaskId/${taskId}`
  //   );

  getManualTodoHistory = (data:any):Promise<AxiosResponse<manualTodoHistory[]>> => 
    this.fetcher.post(`${this.baseUrl}${this.getData}`,data)

  // Automated Todos
  getTodoListByUserId = (data: any): Promise<AxiosResponse<TodoModel[]>> =>
    this.fetcher.post(`${this.baseUrl}${this.getData}`, data);

  getManualTodosById = (data:any):Promise<AxiosResponse<TodoModel[]>> =>
   this.fetcher.post(`${this.baseUrl}${this.getData}`,data);

  uploadManualTodosFile = (todoUuid: string, files: any) => {
    const formData = new FormData();
    files.forEach((file:any)=>{
      formData.append("files", file);
    });
    formData.append("todoUuid ", todoUuid);
    const config = {
      headers: {
        "content-type": "multipart/form-data",
      },
    };
    return this.fetcher
      .post(`${this.baseUrl}users/uploadManualTodosFile`, formData, config)
      .then((response) => response)
      .catch((error) => error);
  }
  
  markTodoAsFlagged(id: string, unflagTodo: boolean) {
    return this.fetcher.post<any>(`${this.baseUrl}todo/markTodoAsFlagged/${id}?unflagTodo=${unflagTodo}`);
  }

  createManualTodo = (data:any):Promise<AxiosResponse<string>> =>
     this.fetcher.post(`${this.baseUrl}users/createManualTodo`,data);

  deleteTodoFile = (fileId:string) => 
   this.fetcher.delete(`${this.baseUrl}users/deleteTodoFile?fileId=${fileId}`)

  updateTodo = (data: any) =>
    this.fetcher.post(`${this.baseUrl}prospect/updateData`, data);

  getOrgLogos = (orgId: any) => {
    return this.fetcher.get(
      `${this.themeBaseUrl}theme/getOrgLogos?screenName=AdminPortal&orgId=${orgId}`
    );
  };



  /* Message Center - start */

  // saveMessageThreadByQuestionId(body:any){
  //   return this.fetcher.post<any>(`${this.messageCenterUrl}messagecenter/saveNewMessageThread`, body);
  // }

  postSaveMessageThread = async (data: any) =>
    this.fetcher.post(
      `${this.messageCenterUrl}messagecenter/saveNewMessageThread`,
      data
    );

    

  postSaveMessage = async (data: any) =>
    this.fetcher.post(
      `${this.messageCenterUrl}messagecenter/saveMessage`,
      data
    );

    saveAttachment(formData:any){
      const config = {
        headers: {
          'content-type': 'multipart/form-data',
        }
      };
      return this.fetcher.post(`${this.messageCenterUrl}messagecenter/saveAttachment`, formData, config);
    }

  postSaveAttachment = async (file: any, data: postMessageData) => {
    if (file) {
      const formData = new FormData();
      formData.append("multipartFile", file);
      formData.append("context ", JSON.stringify(data));

      const config = {
        headers: {
          "content-type": "multipart/form-data",
        },
      };
      return this.fetcher
        .post(
          `${this.messageCenterUrl}messagecenter/saveAttachment`,
          formData,
          config
        )
        .then((response) => response)
        .catch((error) => error);
    }
  };

  updateThreadArchiveFlag = (contextId: string, archiveFlag: boolean) =>
    this.fetcher.put(
      `${this.messageCenterUrl}messagecenter/updateThreadArchiveFlag?contextId=${contextId}&archiveFlag=${archiveFlag}`
    );

  updateThreadPinnedFlag = (contextId: string, pinnedFlag: boolean) =>
    this.fetcher.put(
      `${this.messageCenterUrl}messagecenter/updateThreadPinnedFlag?contextId=${contextId}&pinnedFlag=${pinnedFlag}`
    );

  updateThreadReadFlag = (contextId: string) =>
    this.fetcher.put(
      `${this.messageCenterUrl}messagecenter/updateThreadReadFlag?contextId=${contextId}`
    );

  getFinRecipient = () =>
    this.fetcher.get(`${this.messageCenterUrl}messagecenter/getFinRecipient`);

  getMessageThread = (): Promise<AxiosResponse<MessageThreadModel[]>> =>
    this.fetcher.get(
      `${this.messageCenterUrl}messagecenter/getMessageThreadBankPortal`
    );

    getMessageThreads(userId:string):Promise<AxiosResponse<MessageThread[]>>{
      return this.fetcher.get(`${this.messageCenterUrl}messagecenter/getMessageThreadBankPortal?userId=${userId}`);
    }

  getMessageThreadsByClientPortal = (
    customerUserId: string
  ): Promise<AxiosResponse<MessageThreadModel[]>> =>
    this.fetcher.get(
      `${this.messageCenterUrl}messagecenter/getCustomerMessagesBankPortal?customerUserId=${customerUserId}`
    );

  getMessages = (contextId: string) =>
    this.fetcher.post(
      `${this.messageCenterUrl}messagecenter/getMessages?contextId=${contextId}`
    );

  getUnreadMessageCount = () =>
    this.fetcher.get(
      `${this.messageCenterUrl}messagecenter/getUnreadMessageCount`
    );

  downloadAttachment = (filePath: string,fileId?:string) =>
    this.fetcher.get(
      `${this.messageCenterUrl}messagecenter/downloadAttachment?filePath=${filePath}&fileId=${fileId}`
    );

  ////////forgotpassword API /////////
  forgotUsername = (data: any) =>
    this.fetcher.post(`${this.baseUrl}users/forgotUsername`, data);

  forgotPassword = (data: any) =>
    this.fetcher.post(`${this.baseUrl}users/forgotPassword`, data);

  resetPassword = (data: any) =>
    this.fetcher.post(`${this.baseUrl}users/resetPassword`, data);

  changePassword = (data: any) =>
    this.fetcher.post(`${this.baseUrl}users/changePassword`, data);

  /* Message Center - end */

  /////Case Tracker API's here/////

  getCaseFilterData() {
    return this.fetcher.get(`${this.CASE_BASE_URL}finresult/getCaseFilter`);
  }
  getCaseList(postData: any): Promise<AxiosResponse<CaseResponseModel[]>> {
    const value = JSON.stringify(postData);
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    return this.fetcher
      .post<CaseResponseModel[]>(
        `${this.CASE_BASE_URL}finresult/getCaseList`,
        value,
        config
      )
      .then((response) => response)
      .catch((error) => error);
  }
  getAllLORClients = (orgId: any) => {
    return this.fetcher.get(
      `${this.CASE_BASE_URL}finresult/getAllLORClients/${orgId}`
    );
  };
  getFinCaseByCaseId = (
    caseId: string
  ): Promise<AxiosResponse<ICaseDetailsModel>> => {
    return this.fetcher.get(
      `${this.CASE_BASE_URL}finresult/getFinCaseByCaseId?caseId=${caseId}`
    );
  };

  getLeadInfoDetails (data:any) {
   return this.fetcher.get(`${this.BaseUrl}questionarie/getLeadInfoById?clientProductId=${data}`);
  }

  getClientLeadInfoDetails(
    id: string | null | undefined
  ): Promise<AxiosResponse<any>> {
    return this.fetcher
      .get<any>(`${this.CASE_BASE_URL}questionarie/getLeadInfoById?clientProductId=${id}`)
      .then((response: any) => {
        if (response?.response?.status == 400) {
          throw response;
        }
        return response;
      })
      .catch((error: AxiosError) => {
        throw error;
      });
  }
  getRecommendationDetails(clientId: string | null | undefined){
    return this.fetcher.get<CategoryDetails>(
      `${this.BaseUrl}questionarie/getRecommendationDetails/${clientId}`
    );
  }
  getAllManualTodoUsers = (orgId: any,todoTypeId:any): Promise<AxiosResponse<any[]>> => {
    return this.fetcher.get(
      `${this.CASE_BASE_URL}finresult/getAllManualTodoUsers/${orgId}?todoTypeId=${todoTypeId}`
    );
  };

  getAllBankUsers = (data:any): Promise<AxiosResponse<any[]>>=>
  this.fetcher.post(`${this.baseUrl}${this.getData}`,data)

  getUserIdByClientId(clientProductId:string | null | undefined){
    return this.fetcher.get(`${this.baseUrl}questionarie/getUserIdByClientId/${clientProductId}`);
  }

  createFinCase(body: any, files?: any) {
    console.log(files, "files");
    const formData = new FormData();
    formData.append("finCaseRequestDTO", JSON.stringify(body));
    if (files) {
      files.forEach((file: any) => {
        formData.append("files", file);
      });
    }
    const config = { headers: { "content-type": "multipart/form-data" } };
    return this.fetcher.post(
      `${this.CASE_BASE_URL}finresult/createOrUpdateFinCase`,
      formData,
      config
    );
  }
  editCaseTask = (data: IEditCaseTaskInput) =>
    this.fetcher.put(`${this.CASE_BASE_URL}finresult/editCaseTask`, data);

  verifyTask = (data: ICaseTaskInput) =>
    this.fetcher.post(`${this.CASE_BASE_URL}finresult/verifyTask`, data);

  getCaseTaskByTaskId = (caseId: string, taskId: string) =>
    this.fetcher.get(
      `${this.CASE_BASE_URL}finresult/getCaseTaskByTaskId?caseId=${caseId}&taskId=${taskId}`
    );

  createCaseTask = (data: ICaseTaskInput) =>
    this.fetcher.post(`${this.CASE_BASE_URL}finresult/createCaseTask`, data);

  getCaseCommentsByCaseId = (
    caseId: string,
    search: string | undefined
  ): Promise<AxiosResponse<ICaseCommentModel[]>> =>
    this.fetcher.get(
      `${this.CASE_BASE_URL}finresult/getCaseCommentsByCaseId?caseId=${caseId}&search=${search}`
    );

  deleteCaseComment = (commentId: string) =>
    this.fetcher.delete(
      `${this.CASE_BASE_URL}finresult/deleteCaseComment/${commentId}`
    );

  updateCaseCommentByCommentId = (data: IAddCaseInput) =>
    this.fetcher.put(
      `${this.CASE_BASE_URL}finresult/updateCaseCommentByCommentId`,
      data
    );

  addCaseComment = (data: IAddCaseInput) =>
    this.fetcher.post(`${this.CASE_BASE_URL}finresult/addCaseComment`, data);

  getCaseDocumentFile = (documentId: string) =>
    this.fetcher.post(
      `${this.CASE_BASE_URL}finresult/getCaseDocumentFile?documentId=${documentId}`
    );

  getCaseTaskListByCaseId = (
    caseId: string,
    type: string | number,
    taskId?: string | null
  ): Promise<AxiosResponse<ICaseTaskModel[]>> => {
    let url = `${this.CASE_BASE_URL}finresult/getCaseTaskListByCaseId?caseId=${caseId}&type=${type}`;
    if (taskId) {
      url = `${url}&taskId=${taskId}`;
    }
    return this.fetcher.get(url);
  };
  getManualTodoFile = (documentUuid: string) => {
    return this.fetcher.post(
      `${this.CASE_BASE_URL}todo/getManualTodoFile?documentId=${documentUuid}`
    );
  };
  getTaskHistorybyTaskId = (
    taskId: string
  ): Promise<AxiosResponse<ICaseTaskHistoryModel[]>> =>
    this.fetcher.get(
      `${this.CASE_BASE_URL}finresult/getTaskHistorybyTaskId/${taskId}`
    );

  changeCaseStatus = (caseId: string) => {
    return this.fetcher.put(
      `${this.CASE_BASE_URL}finresult/changeCaseStatus?caseId=${caseId}`
    );
  };

  getCaseDocumentsList = (
    caseId: string
  ): Promise<AxiosResponse<ICaseDocumentModel[]>> =>
    this.fetcher.get(
      `${this.CASE_BASE_URL}finresult/getCaseDocumentsList?caseId=${caseId}`
    );

  ///////////////////////////////////////////////////////////////////////

  getNdaPrequalQuestions = (
    clientId: string,
    clientProductId: string
  ): Promise<AxiosResponse<any>> => {
    return this.fetcher.get(
      `${this.QUESTIONNAIRE_URL}questionarie/getNdaPrequalQuestions?clientId=${clientId}&clientProductId=${clientProductId}`
    );
  };

  getContractPrequalQuestions = (
    clientId: string,
    clientProductId: string
  ): Promise<AxiosResponse<any>> => {
    return this.fetcher.get(
      `${this.QUESTIONNAIRE_URL}questionarie/getContractPrequalQuestions?clientId=${clientId}&clientProductId=${clientProductId}`
    );
  };

  getDdaPrequalQuestions = (
    clientId: string,
    clientProductId: string
  ): Promise<AxiosResponse<any>> => {
    return this.fetcher.get(
      `${this.QUESTIONNAIRE_URL}questionarie/getDDAPrequalQuestions?clientId=${clientId}&clientProductId=${clientProductId}`
    );
  };

  getPaymentPrequalQuestions = (
    clientId: string,
    clientProductId: string
  ): Promise<AxiosResponse<any>> => {
    return this.fetcher.get(
      `${this.QUESTIONNAIRE_URL}questionarie/getPaymentPrequalQuestions?clientId=${clientId}&clientProductId=${clientProductId}`
    );
  };

  updateEntity = (data: IAPIPayload) =>
    this.fetcher.post(`${this.baseUrl}${this.updateData}`, data);

  saveClientResponse = (data: any) =>
    this.fetcher.post(
      `${this.QUESTIONNAIRE_URL}questionarie/saveNDAClientResponse`,
      data
    );

  removeResponses = (clientQuestionId: number) =>
    this.fetcher.post(
      `${this.QUESTIONNAIRE_URL}questionarie/removeNDAResponses/${clientQuestionId}`
    );

  // docu sign

  getDocusignUrl(clientId: any, signingOption: string, url: string) {
    // eslint-disable-next-line max-len
    return this.fetcher.post(
      `${this.docuSignUrl}docuSign/embeddedSigning?clientId=${clientId}&signingOption=${signingOption}&returnUrl=${url}`
    );
  }

  docuSignWebhook(
    event: any,
    envelopeId: any,
    clientUuid: any,
    signingOption: any
  ) {
    // eslint-disable-next-line max-len
    return this.fetcher.get(
      `${this.docuSignUrl}docuSign/docuSignReturn?event=${event}&envelopeId=${envelopeId}&clientUuid=${clientUuid}&signingOption=${signingOption}`
    );
  }

  // : Promise<AxiosResponse<signStatus>>
  getSignerStatus = (payload: any): Promise<AxiosResponse<ISignStatusModel[]>> =>
    this.fetcher.post<ISignStatusModel[]>(`${this.docuSignUrl}docuSign/getSignerStatus`, payload)

  downloadDocuSignReport(signingOption: string, clientUuid: string) {
    // eslint-disable-next-line max-len
    return this.fetcher.get(
      `${this.docuSignUrl}docuSign/downloadDocument?signingOption=${signingOption}&clientId=${clientUuid}`
    );
  }

  /* action btns----DocuSign */
  
  getDocuSignDocument = (data: IDocuSignDocumentInput) =>
    this.fetcher.post(`${this.docuSignUrl}docuSign/getDocuSignDocument`, data);

  btnsUpdateData = (payload: any): Promise<AxiosResponse<IActionBtnsModel[]>> =>
    this.fetcher.post(`${this.baseUrl}${this.updateData}`, payload);

  resendEnvelope = (payload: any): Promise<AxiosResponse<IActionBtnsModel[]>> =>
  this.fetcher.post(`${this.baseUrl}docuSign/resendEnvelope`, payload);   

  editEmail = (payload: any): Promise<AxiosResponse<IActionBtnsModel[]>> =>
  this.fetcher.post(`${this.baseUrl}docuSign/editEmail`, payload); 

  envelopeExpiryDate  = (payload: any): Promise<AxiosResponse<IActionBtnsModel[]>> =>
  this.fetcher.post(`${this.baseUrl}docuSign/checkEnvelopeExpiry`, payload);   

    ////admin-settings//////////
updateAdminUsers = (data: any) =>
this.fetcher.post(`${this.baseUrl}${this.updateUser}`, data);

updateUserEnableOrDisable = (userId: any,enableorDisable:boolean) =>
this.fetcher.post(`${this.baseUrl}users/updateUserEnableOrDisable/${userId}/${enableorDisable}`);

/////////Dashboard Kpis///////////

getKPIDashBoard = (data: any) =>
this.fetcher.post(`${this.baseUrl}prospect/getKPIDashBoard`,data);
//compliance
getdashboardBarChart =(data:any)=>
this.fetcher.post(`${this.baseUrl}prospect/getdashboardBarChart`,data);

getComplianceCategoriesByClientId = (selectedClientProductId: any) =>
this.fetcher.get(`${this.baseUrl}questionarie/getComplianceCategoriesByClientId/${selectedClientProductId}`);



getcategoryDetails=(categoryId: string | undefined, clientProductId: string | null | undefined)=> 
  this.fetcher.get(`${this.baseUrl}questionarie/getComplianceSubcategoriesByCategoryId/${categoryId}/${clientProductId}`);

  getSubCategoriesByCategoriesId=(categoryId: string, clientProductId: string | null | undefined): Promise<AxiosResponse<CategoryDetails>> =>{
    // eslint-disable-next-line max-len
    return this.fetcher.get<CategoryDetails>(`${this.BaseUrl}questionarie/getsubcategoriesByCategoryId?categoryId=${categoryId}&clientProductId=${clientProductId}`)
      }

getCategoriesByClientId = (selectedClientProductId: any) =>
this.fetcher.get(`${this.baseUrl}questionarie/getCategoriesByClientId?clientProductId=${selectedClientProductId}`);
getOverallPercentage = (selectedClientProductId: any) =>
this.fetcher.get(`${this.baseUrl}questionarie/getOverallPercentage?clientProductId=${selectedClientProductId}`);



  /////////////OwnerShip///////////////////
 
  getFirstQuestion (clientProductId:string|undefined|null): Promise<AxiosResponse<OwnershipInformationdata[]>>{ 
    return this.fetcher.get(`${this.baseUrl}questionarie/getWelcomeQuestion?clientProductId=${clientProductId}`)}


  deleteFileForOwner(ownerId:any,questionId: number, filePath: any) {
    return axios.delete(
      `${this.BaseUrl}questionarie/deleteFileForOwner?ownerId=${ownerId}&questionId=${questionId}&filePath=${filePath}`)
      .then(response => response)
      .catch(error => error);
  }
  validationByAiForOwners(file: any, questionId: number) {
    const formData = new FormData();
    if (file) {
      formData.append('multipartFile', file);
      formData.append('questionId ', questionId.toString());
    }
    const config = {
      headers: {
        'content-type': 'multipart/form-data',
      },
    };
    return axios.post(`${this.BaseUrl}questionarie/validationByAiForOwners`, formData, config)
      .then(response => response)
      .catch(error => error);
  }
 

  postOwnerFileUsingPOST(file:any,ownerId:any,questionId:any,aiOverride:boolean){
    const formData = new FormData();
    if (file) {
      formData.append('multipartFile', file);
      // formData.append('clientQuestionId ', clientQuistionId.toString());
    }
    const config = {
      headers: {
        'content-type': 'multipart/form-data',
      },
    };
    // eslint-disable-next-line max-len
    return axios.post(`${this.BaseUrl}questionarie/postOwnerFile?aiOverride=${aiOverride}&ownerId=${ownerId}&questionId=${questionId}`,
    formData,config).then(response => response)
    .catch(error => error);
  }

  saveOwnerResponse(data:any){
    const token: any = localStorage.getItem("token");
    return this.fetcher({
      method: "post",
      url: `${this.BaseUrl}owners/saveOwnerResponse`,
      data: data,
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });
  }
  
  removeOwnerResponse(ownerId:string|undefined,ownerQuestionId:number,clientProductsId:string|undefined){
    return this.fetcher.delete(`${this.BaseUrl}owners/removeOwnerResponse?ownerId=${ownerId}&ownerQuestionId=${ownerQuestionId}&clientProductsId=${clientProductsId}`)
  }

  
  postOwnerInformation(data:saveOwnershipInformationdata) {
    return this.fetcher.post<any>(`${this.API_Base_Url}owners/saveOrUpdateOwnerInfo`,data)
  
  }
  deleteContact(ownerId:any,clientProductsId:any){  
    return this.fetcher.delete(`${this.BaseUrl}owners/deleteOwners?ownerId=${ownerId}&clientProductsId=${clientProductsId}`)
  }
  
  getAllContacts(clientProductsId:string|undefined|null): Promise<AxiosResponse<OwnershipInformationdata[]>>{  
    return this.fetcher.get(`${this.BaseUrl}owners/getOwnerIndvidualInformation?clientProductsId=${clientProductsId}`);
   // return axios.get(`${this.BaseUrl}getOwnerIndvidualInformation/${clientId}`)

  }
  getOwnersOfTypeIndividuals(clientProductsId:string): Promise<AxiosResponse<OwnershipInformationdata[]>>{  
    return this.fetcher.get(`${this.BaseUrl}owners/getOwnersOfTypeIndividuals?clientProductsId=${clientProductsId}`)
  }

  getOwnersForAdditionalInformation(clientProductsId:string):Promise<AxiosResponse<OwnersForAdditionalInformation[]>>{
    return this.fetcher.get<OwnersForAdditionalInformation[]>(`${this.BaseUrl}owners/getOwnersForAdditionalInformation?clientProductsId=${clientProductsId}`)
  }

  getAdditionalOwnerQuestions(ownerId:string, entityType:string, groupType:string):Promise<AxiosResponse<any[]>>{
    return this.fetcher.get<any>(`${this.BaseUrl}owners/getAdditionalOwnerQuestions/${ownerId}/${groupType}/${entityType}`)
  }

  updateIndividualOwner(data:any){
    return this.fetcher.post(`${this.BaseUrl}owners/saveOrUpdateIndividualOwner`,data)
  }
  postSaveOwnerResponse(data:saveOwnershipInformationdata) {
    return this.fetcher.post<any>(`${this.API_Base_Url}owners/saveOwnerResponse`,data)  
  }
  getAllOwnersOfCompany(clientProductsId:string): Promise<AxiosResponse<OwnershipInformationdata[]>>{  
    return this.fetcher.get(`${this.BaseUrl}owners/finresult/getAllOwnersOfCompany/${clientProductsId}`)
  }
  postSaveStockSymbol(data:string){  
    return this.fetcher.post<any>(`${this.BaseUrl}owners/saveStockSymbolForClients`,data)
  }
  getStockSymbol(clientProductsId:string|undefined|null){  
    return this.fetcher.get(`${this.BaseUrl}owners/getStockSymbolForClients?clientProductsId=${clientProductsId}`)
  }
  deleteAllOwners(parentOwnerId:any,clientProductsId:any){  
    let url;
    if(parentOwnerId){
      url = `${this.BaseUrl}owners/deleteAllOwners?parentOwnerId=${parentOwnerId}?clientProductsId=${clientProductsId}`;
    } else {
      url = `${this.BaseUrl}owners/deleteAllOwners?clientProductsId=${clientProductsId}`;
    }
    return this.fetcher.delete(url);
  }
  saveOrUpdateGroupofIndividuals(body:any): Promise<AxiosResponse<any>>{
    return this.fetcher.post(`${this.BaseUrl}owners/saveOrUpdateGroupofIndividuals`,body)
  } 
  removeIndividualFromGroup(individualId:string): Promise<AxiosResponse<any>>{
    return this.fetcher.delete(`${this.BaseUrl}owners/removeIndividualFromGroup/${individualId}`)
  }
  makeAuthSignerPrimary(ownerId:string,isPrimary:boolean) : Promise<AxiosResponse<any>>{
    return this.fetcher.post(`${this.BaseUrl}owners/makeAuthSignerPrimary/${ownerId}/${isPrimary}`)
  }
  getStatesData(data:any): Promise<AxiosResponse<State[]>> {
    return this.fetcher.post(`${this.BaseUrl}${this.getData}`,data)
  }
  getComplianceOverallPercentage(
    clientProductId: string | null | undefined
  ): Promise<AxiosResponse<OverallPercentage>> {
    return this.fetcher.get<OverallPercentage>(
      `${this.baseUrl}questionarie/getComplianceOverallPercentage/${clientProductId}`
    );
  }

  postsaveQuestionReview(
    data: any
  ): Promise<AxiosResponse<saveQuestionReview>> {
    return this.fetcher.post<saveQuestionReview>(
      `${this.baseUrl}questionarie/saveQuestionReview`,
      data
    );
  }


  addClientCustomQuestion(body:any): Promise<AxiosResponse<string>>{
    return this.fetcher({
      method: "post",
      url: `${this.BaseUrl}questionarie/addClientCustomQuestion`,
      data: body,
    });
  }

  removeClientCustomQuestion(clientQuestionId:any,isClientCustomQuestion:any){
    // eslint-disable-next-line max-len
    return this.fetcher.delete(`${this.BaseUrl}questionarie/removeClientCustomQuestion/${clientQuestionId}/${isClientCustomQuestion}`)
  }

  getComplinaceQuestionsBySubCategoryId(
    clientProductId: string | null | undefined,
    subCategoryId: string | undefined
  ) {
    return this.fetcher.get(
      `${this.baseUrl}questionarie/getComplinaceQuestionsBySubCategoryId/${subCategoryId}/${clientProductId}`
    );
  }
  getComplinaceQuestionsByClientId(clientId: string| null | undefined, clientProductId:string| null | undefined): Promise<AxiosResponse<Array<SubCategoryQuestion>>> {
    return this.fetcher.get<Array<SubCategoryQuestion>>(`${this.baseUrl}prospect/getSummaryReport/${clientId}/${clientProductId}`
    );

  }

  getMessageThreadsByQuestionId(userId:string, questionId:any):Promise<AxiosResponse<MessageThread>>{
    return this.fetcher.get(
      `${this.messageCenterUrl}messagecenter/getMessageThreadByQuestionId?clientId=${userId}&questionId=${questionId}`
    );
  }

  getQuestionGuidance=(questionsList:any)=> { 
    return this.fetcher.post(`${this.baseUrl}questionarie/getQuestionGuidance`,questionsList);
  }
  
  getReviewProgress=(id:string)=> { 
    return this.fetcher.get(`${this.baseUrl}questionarie/getReviewProgress/${id}`);
  }
  
  getClientNotes=(id:string| null | undefined)=> { 
    return this.fetcher.get(`${this.baseUrl}questionarie/getClientNotes/${id}`);
  } 

  postInsertClientNotes=(body:postClientNotes)=> { 
    return this.fetcher.post(`${this.baseUrl}questionarie/insertClientNotes`,body);
  }
  
  getIteamHistory(
    reviewClientQuestionId: any
  ): Promise<AxiosResponse<Array<HistoryInfo>>> {
    return this.fetcher.get<Array<HistoryInfo>>(`${this.baseUrl}questionarie/getIteamHistory/${reviewClientQuestionId}`);
  }
  
      //Mangement Review
      changeRecommendation = (data:any): Promise<AxiosResponse<any>> => 
      this.fetcher.post(`${this.baseUrl}questionarie/changeRecommendation`, data
      );
     
      getRecommendationStatus = (clientProductId:string): Promise<AxiosResponse<any>> => 
       this.fetcher.get(`${this.baseUrl}questionarie/getRecommendation/${clientProductId}`
      );
      
      listenChildWindow = () => {
       window.addEventListener("message", (event)=>{
         console.log('event', event);
         if(event.data.from === 'approveClient'){
           window.location.reload();
         }
       }, false);
      }
  postSubmitCompliance(reviewStatus: string, clientProductId: string | null | undefined) {
    return this.fetcher.post(
      `${this.BaseUrl}questionarie/submitCompliance/${reviewStatus}/${clientProductId}`
    );
  }

  postSaveClientResponse(data: postQuestionData | unknown) {
    return this.fetcher({
      method: "post",
      url: `${this.BaseUrl}questionarie/saveClientResponse`,
      data: data
    })
  }
  
  postRemoveresponseData(clientquestionarieId: any, clientProductId:any) {
    return this.fetcher({
      method: "post",
      url: `${this.BaseUrl}questionarie/removeResponses?clientQuestionId=${clientquestionarieId}&clientProductId=${clientProductId}`
    })
  }

  addQuestionGroup(data:any){
    return this.fetcher.post(`${this.BaseUrl}questionarie/addQuestionGroup`, data);
  }

  removeQuestionGroup(data:any){
    return this.fetcher.post(`${this.BaseUrl}questionarie/removequestiongroup`, data);
  }

  removeQuestionGroupBulk(data:any){
    return this.fetcher.post(`${this.BaseUrl}questionarie/removequestiongroupbulk`, data);
  }
  

  getQuestionsBySubCategoryId(subCategoryId: string|undefined , clientProductId: string|undefined): Promise<AxiosResponse<SubCategoryQuestionsForClientPortal>> {
    return this.fetcher.get(`${this.BaseUrl}questionarie/getQuestionsBySubCategoryId?subcategoryId=${subCategoryId}&clientProductId=${clientProductId}`)
  }

  validationByAi(file: any, clientQuistionId: number) {
    const formData = new FormData();
    if (file) {
      formData.append('multipartFile', file);
      formData.append('clientQuestionId ', clientQuistionId.toString());
    }
    const config = {
      headers: {
        'content-type': 'multipart/form-data',
      },
    };
    return this.fetcher.post(`${this.BaseUrl}questionarie/validationByAi`, formData, config).then(response => response)
      .catch(error => error);
  }
  


  postFileForClientPortal(file: any, clientQuistionId: number, aiOverride:boolean) {
    const formData = new FormData();
    if (file) {
      formData.append('multipartFile', file);
    }
    const config = {
      headers: {
        'content-type': 'multipart/form-data',
      },
    };
    // eslint-disable-next-line max-len
    return this.fetcher.post(`${this.BaseUrl}questionarie/postFile?aiOverride=${aiOverride}&clientQuestionId=${clientQuistionId}`,
     formData, config).then(response => response)
      .catch(error => error);
  }

  postFile(file: any, clientQuistionId: number,aiOveride?:boolean) {
    const formData = new FormData();
    if (file) {
      formData.append("multipartFile", file);
      formData.append("clientQuestionId ", clientQuistionId.toString());
    }
    const config = {
      headers: {
        "content-type": "multipart/form-data",
      },
    };
    return this.fetcher
    .post(`${this.BaseUrl}questionarie/postFile`, formData, config)
    .then((response) => response)
    .catch((error) => error);
  }

  deleteClientFile(clientquestionarieId:number,filePath:any,clientProductId:any){
    return this.fetcher.delete(`${this.BaseUrl}questionarie/deleteFile?clientQuestionId=${clientquestionarieId}&filePath=${filePath}&clientProductId=${clientProductId}`)
  }

  deleteComplianceFile(clientquestionarieId: number, filePath: any) {
    return this.fetcher
      .delete(
        `${this.BaseUrl}questionarie/deleteFile?clientQuestionId=${clientquestionarieId}&filePath=${filePath}`
      )
      .then((response) => response)
      .catch((error) => error);
  }

  clientIdByClientProductId=(data:any)=>
  this.fetcher.post(`${this.baseUrl}${this.getData}`,data);
  //logout
  
  logOut(data:any): Promise<AxiosResponse<State[]>> {
    return this.fetcher.get(`${this.BaseUrl}authorization/logoutApp?accesstoken=${data.accessToken}&refreshtoken=${data.refreshToken}&clientId=${data.clientId}&sessionExpired=${data.sessionExpired}&userId=${data.userId}`)
  }

  postSaveWelcomeClientResponse(data: postQuestionData | unknown) {
    const token: any = localStorage.getItem("token");
    return this.fetcher({
      method: "post",
      url: `${this.BaseUrl}questionarie/saveWelcomeQuestion`,
      data: data,
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });

  
  }

  updateClientProductStatus(){
    return this.fetcher.post(`${this.BaseUrl}questionarie/updateClientProductStatus`)
  }


  firstLogin(data:any){
    return this.fetcher.post(`${this.BaseUrl}prospect/getData`,data)
  }

  getArchiveOptions(data:any){
    return this.fetcher.post(`${this.BaseUrl}${this.getData}`,data);
  }

  updateArchiveStatus(data:any){
    return this.fetcher.post(`${this.BaseUrl}prospect/updateArchiveStatus`,data)
  }

  reactiveArhiveStatus(data:any){
    return this.fetcher.post(`${this.BaseUrl}prospect/updateReactiveStatus`,data)
  }
  postCategoryComment = (data: any) =>
  this.fetcher.post(`${this.BaseUrl}questionarie/postCategoryComment`, data);

  showCorporateStructure=(clientProductId:any,questionarieCategoryId:any): Promise<AxiosResponse<boolean>> => {
    return this.fetcher.get(`${this.BaseUrl}questionarie/isLoanproduct?questionarieCategoryId=${questionarieCategoryId}&clientProductId=${clientProductId}`)
    }

    resetPasswordLinkStatus =(invitationId:any)=>{
      return this.fetcher.get(`${this.BaseUrl}users/resetPasswordLinkStatus/${invitationId}`)
    }

    getProductsDropDown(data:any){
      return this.fetcher.post(`${this.BaseUrl}prospect/getData`,data)
    }

    //downloadAllButton
    donwloadAllButton = (data: any): Promise<AxiosResponse<any>> =>
    this.fetcher.post(`${this.baseUrl}${this.getData}`, data);

    ///////Pricing-Sheet////////////
    getPaymentScheduleByClientId (clientId:any) {
      return this.fetcher.get(`${this.BaseUrl}questionarie/getPaymentScheduleByClientId/${clientId}`);
     }  
     savePaymentSchedule(data:any){
      return this.fetcher.post(`${this.BaseUrl}questionarie/savePaymentSchedule`,data);
     }

     getPaymentList() {
      return this.fetcher.get(`${this.BaseUrl}questionarie/getPaymentList`);
     } 
     getPaymentDetails(id:string) {
      return this.fetcher.get(`${this.BaseUrl}questionarie/getPaymentDetails/${id}`);
     } 
     
     /////////Admin-pricing-setting/////////
     getOrgProductsByPricingOption = (data: any): Promise<AxiosResponse<any>> =>
      this.fetcher.post(`${this.baseUrl}${this.getData}`, data); 


     /////Risk Settings//////////
     getQuestionsData = (data: any): Promise<AxiosResponse<any>> =>
      this.fetcher.post(`${this.baseUrl}${this.getData}`, data);

     onSaveResponse = (data: any): Promise<AxiosResponse<any>> =>
      this.fetcher.post(`${this.baseUrl}questionarie/saveParameterResponse`, data);

     moveToNextStatus = (clientProductId: string): Promise<AxiosResponse<any>> =>
      this.fetcher.post(`${this.baseUrl}prospect/moveToNextStatus/${clientProductId}`);
}





export default Service;
